import {CURRENT_USER_IS_LOADING, DELETE_CURRENT_USER, EDIT_CURRENT_USER, FETCH_CURRENT_USER} from "../userTypes";
import {LOGOUT} from "../../auth/actions/actionTypes";

const initialState = {
    id: 0,
    firstName: "",
    lastName: "",
    roles: [],
    phone: "",
    photo: "",
    email: "",
    projects: "",
    tags:[],
    isPilot: false,
    isCopilot: false,
    message: "",
    status: 0,
    isLoading: false
}

const currentUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case CURRENT_USER_IS_LOADING:
            return {
                ...state,
                isLoading: true
            }
        case FETCH_CURRENT_USER:
            return {
                ...state,
                id: action.payload.id,
                firstName: action.payload.firstName,
                lastName: action.payload.lastName,
                roles: action.payload.roles,
                tags:action.payload.tags,
                phone: action.payload.phone,
                photo: action.payload.photo,
                email: action.payload.email,
                projects: action.payload.projects,
                isPilot: action.payload.isPilot,
                isCopilot: action.payload.isCopilot,
                message: action.payload.message,
                status: action.payload.status,
                isLoading: false
            }
        case EDIT_CURRENT_USER:
            return {
                ...state,
                id: action.payload.id,
                firstName: action.payload.firstName,
                tags:action.payload.tags,
                lastName: action.payload.lastName,
                roles: action.payload.roles,
                phone: action.payload.phone,
                photo: action.payload.photo,
                email: action.payload.email,
                projects: action.payload.projects
            }
        case DELETE_CURRENT_USER:
            return {
                ...state
            }
        case LOGOUT:
            return initialState
        default:
            return {
                ...state
            }
    }
}

export default currentUserReducer;
